import script from "./ManageUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageUsers.vue?vue&type=script&setup=true&lang=js"

import "./ManageUsers.vue?vue&type=style&index=0&id=42a7e8ee&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42a7e8ee"]])

export default __exports__